module.exports = __webpack_public_path__ + "img/cake_n.29026468.png";